export default __webpack_public_path__ + "static/media/smart-home-lock.1716b51f.svg";